'use client';

import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const Checkbox = ({
  value,
  onChange,
  children,
  id,
  disabled,
  className,
}: {
  children: ReactNode;
  value: boolean;
  onChange: () => void;
  id: string;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <span className={twMerge('flex items-center gap-x-1 text-sm cursor-pointer text-neutral-300', className)}>
      <input
        id={id}
        type="checkbox"
        onChange={onChange}
        checked={value}
        disabled={disabled}
        className="w-4 h-4 bg-neutral-950 accent-primary rounded"
      />
      <label htmlFor={id}>{children}</label>
    </span>
  );
};
